module.exports = __webpack_public_path__ + "img/hero-wms.4eee2edf.jpg";